import React from 'react';
import CloseIconComponent from "../../reusable/CloseIconComponent";
import ApplyButtons from "../../reusable/ApplyButtons";

interface Props {
    ids: Array<number | string>,
    onCancel: () => void,
    onSubmit: () => void
}

const BkmWarningForDeleteComponent: React.FC<Props> = ({ids, onCancel, onSubmit}) => {
    return (
        <div className='warning'
             style={{height:"150px"}}
        >
            <div className='warning__title'>
                <h2>Warning</h2>
                <CloseIconComponent handler={onCancel}/>
            </div>

            <div className='warning__content'>
                { `Are you sure you want to remove bookmarks with ids: ${ids.join(', ')}` }
            </div>

            <ApplyButtons OKHandler={onSubmit}
                          cancelHandler={onCancel}
                          disable={false}
            />
        </div>
    );
};

export default BkmWarningForDeleteComponent;